import React from 'react';
import { IconProps } from './IconProps';

const ArrowPathIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21.5 2v6h-6"/>
    <path d="M2.5 22v-6h6"/>
    <path d="M2 11.5A10 10 0 0 1 12 2a10 10 0 0 1 7.4 3.5"/>
    <path d="M22 12.5a10 10 0 0 1-10 10 10 10 0 0 1-7.4-3.5"/>
  </svg>
);

export default ArrowPathIcon;